export default "__VITE_ASSET__5d38c1ee__"